module.exports = __webpack_public_path__ + "img/vertical_4_2_2.eb54f21a.png";